<template>
  <div
    class="booking-engine__airports"
    :class="{ active: departure_airports.length > 0, 'is-current': is_current }"
  >
    <div class="vb-form">
      <div
        @click="
          () => {
            $emit('scroll-into-view');
            $emit('go-to-tab', 2);
          }
        "
        class="booking-engine__airports__form"
      >
        <b-form-input
          ref="input-airports"
          id="input-airports"
          :placeholder="airports_placeholder"
          v-bind="departure_airports"
          class="vb-input"
          :class="{ focus: current_tab === 2 }"
        />
        <div class="booking-engine__airports__icon">
          <vb-icon :name="'airplane'" :color="'666666'" :size="25" />
        </div>
      </div>
      <div class="booking-engine__floating">
        <loader v-if="loading" />
        <div v-else>
          <div v-if="departure_airports_no_results">
            Purtroppo non ci sono disponibilità per questa
            destinazione/passeggeri
            <br /><br />
          </div>
          <div v-else>
            <div class="booking-engine__airports-list">
              <b-row>
                <b-col sm="12">
                  <p class="semibold">Scegli l'aeroporto</p>
                </b-col>
                <b-col
                  sm="6"
                  md="4"
                  v-for="(airport, airport_index) in departure_airports"
                  v-bind:key="_uid + airport_index"
                  class="mb-3 mb-lg-2"
                >
                  <vb-checkbox
                    @change="$emit('airports-changed')"
                    v-model="airport.selected"
                    :vb_options="{
                      text:
                        airport.name.toLowerCase() +
                        ' (' +
                        airport.iata_code +
                        ')',
                      disabled: false,
                    }"
                  />
                </b-col>
              </b-row>
            </div>
            <div class="booking-engine__airports-list-btn">
              <div
                class="mr-2"
                v-show="selected_airports_count > 0 && !has_availabilities"
              >
                Attendi
              </div>
              <vb-button
                @click.prevent="$emit('go-to-tab', 3)"
                :vb_options="{
                  text: 'OK',
                  disabled: !has_availabilities,
                  icon_disabled: 'lock',
                }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get_airports_placeholder } from "./logic";

export default {
  name: "booking-engine-airports",

  props: {
    current_tab: {
      type: Number,
      required: true,
    },
    departure_airports: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    departure_airports_no_results: {
      type: Boolean,
      required: true,
    },
    has_availabilities: {
      type: Boolean,
      required: true,
    },
    is_current: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    airports_placeholder() {
      return get_airports_placeholder(this.departure_airports);
    },
    selected_airports_count() {
      return this.departure_airports.filter((a) => a.selected).length;
    },
  },
};
</script>

<style lang="scss" scoped>
%step {
  z-index: 10;
  height: 100%;
  &:not(.active) {
    pointer-events: none;

    input {
      background: $gray-300;
    }
  }
}

%bg-window {
  padding: 1rem;
  border-radius: 0.313rem;
  margin-top: 0.65rem;
  background-color: $white;
}

.booking-engine {
  $this: &;

  &__floating {
    display: none;
    @extend %bg-window;

    @include media-breakpoint-up(md) {
      position: absolute;
      top: auto;
      left: 0;
      width: 100%;
    }

    @include media-breakpoint-up(lg) {
      width: 150%;
    }

    @include media-breakpoint-up(xl) {
      left: calc(100% / 12 * 5 + #{$grid-gutter-width/6});
      right: calc(100% / 12 - #{$grid-gutter-width/6});
      width: auto;
    }

    // titolo checkbox
    ::v-deep .vb-check__title {
      text-transform: capitalize;

      @at-root #{$this}__airports & {
        font-size: $font-size-base;

        @include media-breakpoint-up(lg) {
          font-size: $font-size-sm;
        }
      }
    }
  }

  // Volo
  &__airports {
    @extend %step;

    &.is-current {
      .booking-engine__floating {
        display: block;
      }
    }

    &__form {
      position: relative;
    }

    &__icon {
      position: absolute;
      top: 50%;
      right: 1rem;
      height: 24px;
      transform: translateY(-50%);
      aspect-ratio: 1 / 1;
      display: flex;
      align-items: center;
      justify-content: center;
      filter: grayscale(100%);
      svg {
        height: 24px;
        width: auto;
      }
    }

    &-list-btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-top: 1px solid $gray-300;
      padding-top: $grid-gutter-width/2;
      margin-top: $grid-gutter-width/2;
    }
  }
}

#input-airports {
  pointer-events: none;
}
</style>
